import {
  IActivityJournalActionHandler,
  IActivityJournalInitialState
} from './interfaces';
import {ActivityJournalsActionsType, SET_ACTIVITY_JOURNALS} from './actions';
import {IActivityXpedition} from '../activities/interfaces';

const ActivityInitialState: IActivityJournalInitialState = {
  activityJournals: []
};

const setJournals = ({
  state,
  payload
}: IActivityJournalActionHandler): IActivityJournalInitialState => {
  return {
    ...state,
    activityJournals: payload as IActivityXpedition[]
  };
};

const activityReducerHandlers = new Map([
  [SET_ACTIVITY_JOURNALS, setJournals]
]);

const activityJournalReducer = (state = ActivityInitialState, action: ActivityJournalsActionsType): IActivityJournalInitialState => {
  const handler = activityReducerHandlers.get(action.type);

  return (handler && {
    ...handler(<IActivityJournalActionHandler>{
      state,
      payload: action.payload
    })
  }) || {...state};
};

export default activityJournalReducer;
